import CONNECTIVITY_CHAMPION_IMAGE from '../../../assets/images/club/badges/connectivity-champion.webp';
import CONNECTIVITY_CHAMPION_IMAGE_IN_PROGRESS from '../../../assets/images/club/badges/connectivity-champion-in-progress.webp';
import IQOS_CLUB_FIRST_STEPS_IMAGE from '../../../assets/images/club/badges/iqos-club-first-steps.webp';
import IQOS_CLUB_FIRST_STEPS_IMAGE_IN_PROGRESS from '../../../assets/images/club/badges/iqos-club-first-steps-in-progess.webp';
import IQOS_EXPERT_IMAGE from '../../../assets/images/club/badges/iqos-expert.webp';
import IQOS_EXPERT_IMAGE_IN_PROGRESS from '../../../assets/images/club/badges/iqos-expert-in-progress.webp';
import QUEST_CHAMPION_IMAGE from '../../../assets/images/club/badges/quest-champion.webp';
import QUEST_CHAMPION_IMAGE_IN_PROGRESS from '../../../assets/images/club/badges/quest-champion-in-progress.webp';
import SWITCH_MASTER_IMAGE from '../../../assets/images/club/badges/switch-master.webp';
import SWITCH_MASTER_LEVEL_1_IMAGE from '../../../assets/images/club/badges/switch-master.webp';
import SWITCH_MASTER_LEVEL_2_IMAGE from '../../../assets/images/club/badges/switch-master.webp';
import SWITCH_MASTER_LEVEL_3_IMAGE from '../../../assets/images/club/badges/switch-master.webp';
import SWITCH_MASTER_IMAGE_IN_PROGRESS from '../../../assets/images/club/badges/switch-master-in-progress.webp';
import SWITCH_MASTER_LEVEL_1_IMAGE_IN_PROGRESS from '../../../assets/images/club/badges/switch-master-in-progress.webp';
import SWITCH_MASTER_LEVEL_2_IMAGE_IN_PROGRESS from '../../../assets/images/club/badges/switch-master-in-progress.webp';
import SWITCH_MASTER_LEVEL_3_IMAGE_IN_PROGRESS from '../../../assets/images/club/badges/switch-master-in-progress.webp';
import WELCOME_TO_IQOS_CLUB_IMAGE from '../../../assets/images/club/badges/welcome-to-iqos-app.webp';
import WELCOME_TO_IQOS_CLUB_IMAGE_IN_PROGRESS from '../../../assets/images/club/badges/welcome-to-iqos-app-in-progress.webp';
import {IAP_FEATURES_CODES} from '../../../consts/iap/iapFeatureCodes';
import badgeLevelTypes from '../../../consts/loyalty/badgeLevelTypes';
import badgeTypes from '../../../consts/loyalty/badgeTypes';
import badgeUnlockRules from '../../../consts/loyalty/badgeUnlockRules';
import milestoneTypes from '../../../consts/loyalty/milestoneTypes';
import rewardTypes from '../../../consts/loyalty/rewardTypes';
import {strCode} from '../../../consts/strCode';

const BADGES_CONFIG = {
    [badgeTypes.WELCOME_TO_IQOS_CLUB]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_WELCOME,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_WELCOME_DESCRIPTION,
        imageSrc: WELCOME_TO_IQOS_CLUB_IMAGE,
        progressImageSrc: WELCOME_TO_IQOS_CLUB_IMAGE_IN_PROGRESS,
        rewardType: rewardTypes.FREE_COFFEE,
        milestones: [milestoneTypes.ADD_APP_TO_HOME_SCREEN],
    },
    [badgeTypes.IQOS_CLUB_FIRST_STEPS]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_FIRST_STEPS,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_FIRST_STEPS_DESCRIPTION,
        imageSrc: IQOS_CLUB_FIRST_STEPS_IMAGE,
        progressImageSrc: IQOS_CLUB_FIRST_STEPS_IMAGE_IN_PROGRESS,
        rewardType: rewardTypes.IQOS_RING,
        milestones: [milestoneTypes.IQOS_CLUB_VIDEO],
    },
    [badgeTypes.CONNECTIVITY_CHAMPION]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_CONNECTIVITY,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_CONNECTIVITY_DESCRIPTION,
        imageSrc: CONNECTIVITY_CHAMPION_IMAGE,
        progressImageSrc: CONNECTIVITY_CHAMPION_IMAGE_IN_PROGRESS,
        rewardType: rewardTypes.TEREA_PACK,
        milestones: [
            milestoneTypes.CONNECT_DEVICE,
            milestoneTypes.CHANGE_DEVICE_COLOR,
            milestoneTypes.EXPLORE_USAGE_INSIGHT,
        ],
    },
    [badgeTypes.IQOS_EXPERT]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_IQOS_EXPERT,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_IQOS_EXPERT_DESCRIPTION,
        imageSrc: IQOS_EXPERT_IMAGE,
        progressImageSrc: IQOS_EXPERT_IMAGE_IN_PROGRESS,
        rewardType: rewardTypes.LEVIA_PACK,
        milestones: [milestoneTypes.READ_ARTICLE_1, milestoneTypes.IQOS_EXPERT_VIDEO, milestoneTypes.IQOS_EXPERT_QUIZ],
    },
    [badgeTypes.QUEST_CHAMPION]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_QUEST_CHAMPION,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_QUEST_CHAMPION_DESCRIPTION,
        imageSrc: QUEST_CHAMPION_IMAGE,
        progressImageSrc: QUEST_CHAMPION_IMAGE_IN_PROGRESS,
        rewardType: rewardTypes.IQOS_DRINK,
        milestones: [milestoneTypes.DO_PUZZLE, milestoneTypes.QUEST_CHAMPION_QUIZ],
        rules: [badgeUnlockRules.DELAY_3_DAYS_AFTER_FIRST_COMPLETION],
    },
    [badgeTypes.SWITCH_MASTER]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_SWITCH_MASTER,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_SWITCH_MASTER_DESCRIPTION,
        imageSrc: SWITCH_MASTER_IMAGE,
        progressImageSrc: SWITCH_MASTER_IMAGE_IN_PROGRESS,
        featureCode: IAP_FEATURES_CODES.SWITCH_MASTER_BADGE,
        levels: [
            badgeLevelTypes.SWITCH_MASTER_LEVEL_1,
            badgeLevelTypes.SWITCH_MASTER_LEVEL_2,
            badgeLevelTypes.SWITCH_MASTER_LEVEL_3,
        ],
        isOrderImportant: true,
        rules: [badgeUnlockRules.CONVERSIONABLE],
    },
    [badgeLevelTypes.SWITCH_MASTER_LEVEL_1]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_SWITCH_MASTER_LEVEL_1,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_SWITCH_MASTER_LEVEL_1_DESCRIPTION,
        imageSrc: SWITCH_MASTER_LEVEL_1_IMAGE,
        progressImageSrc: SWITCH_MASTER_LEVEL_1_IMAGE_IN_PROGRESS,
        rewardType: rewardTypes.TEREA_LEVIA_PACK,
        milestones: [
            milestoneTypes.SWITCH_11,
            milestoneTypes.SWITCH_12,
            milestoneTypes.SWITCH_13,
            milestoneTypes.SWITCH_14,
            milestoneTypes.SWITCH_15,
        ],
        rules: [badgeUnlockRules.CONVERSIONABLE],
        isSubBadge: true,
        isOrderImportant: true,
    },
    [badgeLevelTypes.SWITCH_MASTER_LEVEL_2]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_SWITCH_MASTER_LEVEL_2,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_SWITCH_MASTER_LEVEL_2_DESCRIPTION,
        imageSrc: SWITCH_MASTER_LEVEL_2_IMAGE,
        progressImageSrc: SWITCH_MASTER_LEVEL_2_IMAGE_IN_PROGRESS,
        rewardType: rewardTypes.IQOS_RINGS,
        milestones: [
            milestoneTypes.SWITCH_21,
            milestoneTypes.SWITCH_22,
            milestoneTypes.SWITCH_23,
            milestoneTypes.SWITCH_24,
            milestoneTypes.SWITCH_25,
        ],
        rules: [badgeUnlockRules.DEVICE_REQUIRED, badgeUnlockRules.CONVERSIONABLE],
        isSubBadge: true,
        isOrderImportant: true,
    },
    [badgeLevelTypes.SWITCH_MASTER_LEVEL_3]: {
        titleStrCode: strCode.CLUB_PAGE_BADGE_SWITCH_MASTER_LEVEL_3,
        descriptionStrCode: strCode.CLUB_PAGE_BADGE_SWITCH_MASTER_LEVEL_3_DESCRIPTION,
        imageSrc: SWITCH_MASTER_LEVEL_3_IMAGE,
        progressImageSrc: SWITCH_MASTER_LEVEL_3_IMAGE_IN_PROGRESS,
        rewardType: rewardTypes.IQOS_DRINK,
        milestones: [
            milestoneTypes.SWITCH_31,
            milestoneTypes.SWITCH_32,
            milestoneTypes.SWITCH_33,
            milestoneTypes.SWITCH_34,
            milestoneTypes.SWITCH_35,
        ],
        rules: [badgeUnlockRules.DEVICE_REQUIRED, badgeUnlockRules.CONVERSIONABLE],
        isSubBadge: true,
        isOrderImportant: true,
    },
};

export default BADGES_CONFIG;
